import axios from 'axios';

// Detectar automáticamente la URL base del servidor
const getBaseURL = () => {
  // Si está configurado en .env, usar eso
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  
  // Si estamos en producción (mismo servidor), usar rutas relativas
  if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
    return '/api';
  }
  
  // En desarrollo, usar localhost
  return 'http://localhost:5000/api';
};

const getUploadsURL = () => {
  // Si está configurado en .env, usar eso
  if (process.env.REACT_APP_UPLOADS_URL) {
    return process.env.REACT_APP_UPLOADS_URL;
  }
  
  // Si estamos en producción (mismo servidor), usar rutas relativas
  if (window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
    return '/uploads';
  }
  
  // En desarrollo, usar localhost
  return 'http://localhost:5000/uploads';
};

const API_URL = getBaseURL();
const API_TIMEOUT = parseInt(process.env.REACT_APP_API_TIMEOUT) || 30000;

// URL base para archivos subidos (imágenes)
const UPLOADS_URL = getUploadsURL();

// URL base para WhatsApp
const WHATSAPP_BASE_URL = process.env.REACT_APP_WHATSAPP_BASE_URL || 'https://wa.me/';

// Crear instancia de axios
const api = axios.create({
  baseURL: API_URL,
  timeout: API_TIMEOUT,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor para agregar token a las peticiones
api.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores de respuesta
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token inválido o expirado
      localStorage.removeItem('user');
      const isSessionCheck = String(error.config?.url || '').includes('/auth/me');
      const publicPaths = [
        '/',
        '/sitio',
        '/cava',
        '/catalog',
        '/login',
        '/payment/success',
        '/payment/failure',
        '/payment/pending'
      ];
      const isPublicPage = publicPaths.includes(window.location.pathname);

      if (!isSessionCheck && !isPublicPage) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// Instancia pública de axios (sin interceptor de autenticación)
// Para usar en endpoints públicos como catálogo
const publicApi = axios.create({
  baseURL: API_URL,
  timeout: API_TIMEOUT,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

export { api, publicApi, API_URL, UPLOADS_URL, WHATSAPP_BASE_URL };
export default api;


